import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'generateAvatarImageURL'
})
export class GenerateAvatarImageURLPipe implements PipeTransform {

  transform(url: string) {
    //Replace {size} with 40x40
    url = url.replace('{size}', '50');
    return url;
  }

}
